'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = LocationSearch;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Location = require('@deliveroo/icon-set/react/Location');

var _Location2 = _interopRequireDefault(_Location);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _TextInput = require('../TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

var _InterpolateLinks = require('../InterpolateLinks');

var _InterpolateLinks2 = _interopRequireDefault(_InterpolateLinks);

var _SavedAddress = require('./SavedAddress');

var _SavedAddress2 = _interopRequireDefault(_SavedAddress);

var _AddressSuggestion = require('./AddressSuggestion');

var _AddressSuggestion2 = _interopRequireDefault(_AddressSuggestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'locationSearch': 'ccl-b39915854bc11ca6',
  'card': 'ccl-16309d70923da151',
  'formFields': 'ccl-1d0c61319716e062',
  'inputWrapper': 'ccl-f12893c76dca374c',
  'locateButton': 'ccl-050d4f843c100f2a',
  'savedAddressList': 'ccl-56533419f1c612f6',
  'buttonWrapper': 'ccl-ed0bd2cd28a190ef',
  'suggestions': 'ccl-208b296b2fcd108c',
  'poweredByGoogle': 'ccl-153fe8a4e4dacea6',
  'login': 'ccl-40bf01260c072d8d'
};

/**
 * A component to allow customers to search for restaurants near their location.
 */

function LocationSearch(_ref) {
  var hasCard = _ref.hasCard,
      hasGeolocation = _ref.hasGeolocation,
      value = _ref.value,
      caption = _ref.caption,
      placeholder = _ref.placeholder,
      errorMessage = _ref.errorMessage,
      searchFilterMessage = _ref.searchFilterMessage,
      loginMessageTemplate = _ref.loginMessageTemplate,
      loginUrl = _ref.loginUrl,
      buttonText = _ref.buttonText,
      savedAddresses = _ref.savedAddresses,
      savedAddressLoadingId = _ref.savedAddressLoadingId,
      savedAddressesCaption = _ref.savedAddressesCaption,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onAddressClick = _ref.onAddressClick,
      onLocateClick = _ref.onLocateClick,
      onSubmit = _ref.onSubmit,
      autoComplete = _ref.autoComplete,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      isLocating = _ref.isLocating,
      isLoading = _ref.isLoading,
      suggestions = _ref.suggestions,
      highlightedSuggestion = _ref.highlightedSuggestion,
      onSuggestionClick = _ref.onSuggestionClick,
      inputRef = _ref.inputRef,
      containerRef = _ref.containerRef;

  var locationButton = function locationButton() {
    if (hasGeolocation) {
      return _react2.default.createElement(
        'button',
        { type: 'button', onClick: onLocateClick, className: styles.locateButton },
        _react2.default.createElement(_Icon2.default, { component: _Location2.default, color: 'teal' })
      );
    }

    return null;
  };

  var searchButton = function searchButton() {
    if (buttonText) {
      return _react2.default.createElement(
        'div',
        { className: styles.buttonWrapper },
        _react2.default.createElement(
          _Button2.default,
          {
            isBlock: true,
            isLoading: isLoading,
            onClick: onSubmit,
            adjacentHorizontalSpacing: 'medium'
          },
          buttonText
        )
      );
    }

    return null;
  };

  var helpMessage = searchFilterMessage ? _react2.default.createElement(
    _P2.default,
    { size: 'x-small', color: 'grey', spacing: 'small 0' },
    searchFilterMessage
  ) : null;

  var loginCallToAction = loginMessageTemplate ? _react2.default.createElement(
    _P2.default,
    { size: 'small', color: 'grey', adjacentVerticalSpacing: 'medium' },
    _react2.default.createElement(_InterpolateLinks2.default, {
      template: loginMessageTemplate,
      render: function render(_ref2) {
        var linkText = _ref2.linkText;
        return _react2.default.createElement(
          'a',
          { href: loginUrl, className: styles.login },
          linkText
        );
      }
    })
  ) : null;

  var onSavedAddressClick = function onSavedAddressClick(address) {
    return function (event) {
      event.preventDefault();
      onAddressClick(address);
    };
  };

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames3.default)(styles.locationSearch, _defineProperty({}, styles.card, hasCard)),
      ref: containerRef
    },
    _react2.default.createElement(
      'div',
      { className: styles.formFields },
      _react2.default.createElement(
        'div',
        { className: styles.inputWrapper },
        _react2.default.createElement(_TextInput2.default, {
          inputRef: inputRef,
          id: 'location-search',
          type: 'text',
          name: 'location-search',
          value: value,
          label: caption,
          placeholder: placeholder,
          errorMessage: errorMessage,
          isInvalid: !!errorMessage,
          autoComplete: autoComplete,
          onFocus: onFocus,
          onBlur: onBlur,
          onChange: onChange,
          isLoading: isLocating,
          iconContent: locationButton,
          extraContent: searchButton,
          onKeyDown: onKeyDown
        }),
        !!suggestions.length && _react2.default.createElement(
          'div',
          { className: styles.suggestions },
          _react2.default.createElement(
            'ul',
            null,
            suggestions.map(function (_ref3, index) {
              var placeId = _ref3.placeId,
                  address = _ref3.address,
                  locality = _ref3.locality;
              return _react2.default.createElement(_AddressSuggestion2.default, {
                key: placeId,
                address: address,
                locality: locality,
                isHighlighted: index === highlightedSuggestion,
                onClick: function onClick() {
                  return onSuggestionClick(placeId);
                }
              });
            })
          ),
          _react2.default.createElement('div', { className: styles.poweredByGoogle, title: 'Powered by Google' })
        )
      )
    ),
    !!savedAddresses.length && _react2.default.createElement(
      'div',
      { className: styles.savedAddresses },
      savedAddressesCaption && _react2.default.createElement(
        _P2.default,
        { color: 'grey', size: 'small', spacing: 'medium 0 0 0' },
        savedAddressesCaption
      ),
      _react2.default.createElement(
        'ul',
        { className: styles.savedAddressList },
        savedAddresses.map(function (address) {
          return _react2.default.createElement(_SavedAddress2.default, _extends({
            key: address.id
          }, address, {
            isLoading: savedAddressLoadingId === address.id,
            onClick: onSavedAddressClick(address)
          }));
        })
      )
    ),
    !loginCallToAction && helpMessage,
    loginCallToAction
  );
}

LocationSearch.displayName = 'LocationSearch';
LocationSearch.propTypes = {
  /**
   * Boolean for whether the LocationSearch form should be rendered as a card
   * (i.e. with a white background and rounded corners).
   */
  hasCard: _propTypes2.default.bool,

  /**
   * Boolean for whether the Geolocation search button should be enabled
   */
  hasGeolocation: _propTypes2.default.bool,

  /**
   * Entered value within the search box
   */
  value: _propTypes2.default.string.isRequired,

  /**
   * Caption to the LocationSearch field
   */
  caption: _propTypes2.default.string.isRequired,

  /**
   * Placeholder text within the search text input.
   */
  placeholder: _propTypes2.default.string.isRequired,

  /**
   * Error message to display alongside the text input for invalid input.
   */
  errorMessage: _propTypes2.default.string,

  /**
   * A message related to search filters to display underneath the text input.
   */
  searchFilterMessage: _propTypes2.default.string,

  /**
   * A template string to display a log in call-to-action below the search box.
   * Takes precedence over any supplied searchFilterMessage.
   */
  loginMessageTemplate: _propTypes2.default.string,

  /**
   * The URL any log in call-to-action should link to.
   */
  loginUrl: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !!props.loginMessageTemplate;
  }),

  /**
   * Search button text — if omitted, no search button is rendered, and
   * searching is triggered elsewhere (e.g. a modal location selector).
   */
  buttonText: _propTypes2.default.string,

  /**
   * List of existing saved addresses.
   */
  savedAddresses: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    formattedAddress: _propTypes2.default.string,
    postcode: _propTypes2.default.string,
    coordinates: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired
  })),

  /**
   * Indicates a saved address which is currently loading, following a click event handler.
   */
  savedAddressLoadingId: _propTypes2.default.string,

  /**
   * Caption to display alongside saved addresses, if any are supplied.
   */
  savedAddressesCaption: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !!props.savedAddresses.length;
  }),

  /**
   * Event handler for when the input is first given focus.
   */
  onFocus: _propTypes2.default.func,

  /**
   * Event handler for when the input loses focus.
   */
  onBlur: _propTypes2.default.func,

  /**
   * Event handler when the entered value changes.
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * Event handler for keyboard events whilst focused
   */
  onKeyDown: _propTypes2.default.func,

  /**
   * Event handler for when the geolocation button is clicked.
   */
  onLocateClick: _propTypes2.default.func.isRequired,

  /**
   * Event handler for when the search button is clicked, or the user presses
   * enter inside the text input.
   */
  onSubmit: _propTypes2.default.func.isRequired,

  /**
   * Event handler for when a saved address is clicked.
   */
  onAddressClick: _propTypes2.default.func,

  /**
   * Boolean indicating that browser geolocation is being queried.
   */
  isLocating: _propTypes2.default.bool,

  /**
   * Boolean indicating that the form is searching.
   */
  isLoading: _propTypes2.default.bool,

  /**
   * An autocomplete attribute for the text input, to allow browsers to make
   * autocomplete suggestions.
   */
  autoComplete: _propTypes2.default.oneOf(['postal-code', 'off']),

  /**
   * An array of suggested addresses, based on the user’s entered input
   */
  suggestions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    placeId: _propTypes2.default.string.isRequired,
    address: _propTypes2.default.string.isRequired,
    locality: _propTypes2.default.string
  })),

  /**
   * The currently highlighted suggested address, from keyboard navigation.
   */
  highlightedSuggestion: _propTypes2.default.number,

  /**
   * Click handler for when a suggested address is clicked or selected
   */
  onSuggestionClick: _propTypes2.default.func.isRequired,

  /**
   * Callback to expose the underlying DOM input element associated with the
   * LocationSearch.
   */
  inputRef: _propTypes2.default.func,

  /**
   * Callback to expose the underlying DOM element for the container of
   * the LocationSearch.
   */
  containerRef: _propTypes2.default.func
};

LocationSearch.defaultProps = {
  hasCard: true,
  hasGeolocation: false,
  errorMessage: undefined,
  searchFilterMessage: undefined,
  loginMessageTemplate: undefined,
  loginUrl: undefined,
  buttonText: undefined,
  savedAddresses: [],
  savedAddressLoadingId: undefined,
  savedAddressesCaption: undefined,
  onKeyDown: function onKeyDown() {
    return undefined;
  },
  onFocus: function onFocus() {
    return undefined;
  },
  onBlur: function onBlur() {
    return undefined;
  },
  onAddressClick: function onAddressClick() {
    return undefined;
  },
  isLocating: false,
  isLoading: false,
  autoComplete: 'postal-code',
  suggestions: [],
  highlightedSuggestion: undefined,
  inputRef: undefined,
  containerRef: undefined
};